// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/473/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es6.number.max-safe-integer.js
// module id = 171
// module chunks = 0